export const secondaryColors = {
  stone: '#B5B8A3',
  slateBlue: '#87A5B6',
  lilac: '#A59DEB',
  green: '#73BF60',
  yellow: '#FAC05C',
} as const;
